// extracted by mini-css-extract-plugin
module.exports = {"button":"about-nav-button_button_2tHbZ","is-active":"about-nav-button_is-active_MTDtQ"};